import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["message", "locations", "path"];
// Important KEEP IN VANILLA JAVASCRIPT
var _require = require('@apollo/client'),
  ApolloClient = _require.ApolloClient,
  InMemoryCache = _require.InMemoryCache,
  HttpLink = _require.HttpLink,
  from = _require.from;
var _require2 = require('@apollo/client/link/error'),
  onError = _require2.onError;
var fetch = require('cross-fetch');
import bugsnagClient from '../helpers/BugsnagHelpers';
var config = require('../configuration');
var endPoint = config.api.GRAPH_API_URL;
var FILTERED_CATEGORIES = ['validation', 'authorization', 'authentication'];
var errorLink = onError(function (_ref) {
  var networkError = _ref.networkError,
    graphQLErrors = _ref.graphQLErrors,
    response = _ref.response,
    operation = _ref.operation;
  if (bugsnagClient) {
    if (graphQLErrors) {
      var filteredErrors = graphQLErrors.filter(function (_ref2) {
        var extensions = _ref2.extensions;
        return !FILTERED_CATEGORIES.includes(extensions.category);
      });
      filteredErrors.forEach(function (_ref3) {
        var message = _ref3.message,
          locations = _ref3.locations,
          path = _ref3.path,
          additional = _objectWithoutProperties(_ref3, _excluded);
        var messageToSend = "[GraphQL error]:           Message: ".concat(JSON.stringify(message), ",           Location: ").concat(JSON.stringify(locations), ",           Path: ").concat(JSON.stringify(path), ",           Additional: ").concat(JSON.stringify(additional));
        if (config.app.APP_ENV === 'local') {
          console.error(messageToSend);
        }
        bugsnagClient.notify(new Error(messageToSend), {
          severity: 'error',
          context: 'graphQLErrors',
          metaData: {
            Message: message,
            Location: locations,
            Path: path,
            Operation: operation,
            Response: response,
            Additional: additional
          }
        });
      });
    }
    if (networkError) {
      if (config.app.APP_ENV === 'local') {
        console.error("[Network error]: ".concat(networkError));
      }
      bugsnagClient.notify(new Error("[Network error]: ".concat(networkError)), {
        severity: 'error',
        context: 'graphQLNetworkError',
        metaData: {
          Operation: operation,
          Response: response
        }
      });
    }
  }
});
var httpLink = new HttpLink({
  uri: endPoint,
  fetch: fetch
});
var GraphQLClient = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache()
});
export var defaultConfig = {
  fetchPolicy: 'no-cache',
  errorPolicy: 'all'
};
export default GraphQLClient;